import { styled } from '@mui/material/styles';
import { TableCell, TableCellHeader } from 'shared/mui/Table';

export const TableCellHeaderStyled = styled(TableCellHeader)({
  fontWeight: 400,
  padding: '0 16px 4px',
  border: 'none',
});

export const TableCellStyled = styled(TableCell)({
  padding: '0 16px 4px',
  fontWeight: 500,
  textAlign: 'right',
  border: 'none',
});

export const ColorMarker = styled('div')({
  width: '12px',
  height: '12px',
});
